<template>
  <aha-modal
    :title="$i18nPresenter.t('extra_free_month_activated')"
    classesModal="modal-cancel-process modal-cancel-offer"
    @hide="handleCloseModal"
  >
    <div class="modal-content pt-1">
      <img
        class="success-placeholder w-full h-auto"
        src="@/assets/images/cancel-subscription/get-offer.svg"
        width="354"
        height="199"
        alt="success"
      >
    </div>
    <div
      v-html="$i18nPresenter.t('your_plan_expiry_date', {
        plan: planName,
        date: endDate
      })"
      class="mt-5"
    />
    <div class="mt-4">
      {{ $i18nPresenter.t('continue_enjoy_ahaslides') }}
    </div>
    <template #action>
      <aha-antd-button
        v-aha-emit-action
        v-blur-on-click
        name="get-offer"
        @click="handleCloseModal"
      >
        {{ $i18nPresenter.t('Got it') }}
      </aha-antd-button>
    </template>
  </aha-modal>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  props: {
    propData: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState({
      plan: (state) => state.plan,
    }),
    planName() {
      return this.plan && this.plan.name
    },
    endDate() {
      return this.propData
        && this.propData.newSubscriptionEndDate
        && moment(new Date(this.propData.newSubscriptionEndDate * 1000)).locale('en').format('DD MMM YYYY')
    },
  },
  methods: {
    handleCloseModal() {
      window.location.reload()
    },
  },
}
</script>
